import scrollElementTo from '~/utils/animation/scrollElementTo';
import {spaceNumber} from '~/app/utils/spaceNumber';
import {yearsToMonths} from '~/app/utils/yearsToMonths';
import {initCalculator} from './initCalculator';

export const newCard = () => {
	const apartmentCard = document.querySelector( 'main' );

	if ( !apartmentCard )
	{
		return;
	}

	const toAdvantagesButton = apartmentCard.querySelector( 'button.to-advantages' );
	const advantages = apartmentCard.querySelector( 'section.advantages' );

	if ( toAdvantagesButton && advantages )
	{
		toAdvantagesButton.addEventListener(
			'click',
			() =>
			{
				scrollElementTo( window, advantages.offsetTop, 500 );
			},
		);
	}

	initCalculator( apartmentCard );

	const slideshow = apartmentCard.querySelector( 'section.layouts' );

	if ( !slideshow )
	{
		return;
	}

	const slidesContainer = slideshow.querySelector( 'ul.images' );
	const bookmarksContainer = slideshow.querySelector( 'ul.tabs' );
	const slidesCount = slidesContainer.children.length;
	let currentPosition = 0;
	let currentIndex = 0;
	let timeStamp = 0;
	let touch = null;
	let slidesLength = 0;
	let step = 0;

	if ( slidesContainer && bookmarksContainer )
	{
		const getXCoordinate = ( evt ) => typeof evt.pageX === 'number' ? evt.pageX : evt.touches[0].pageX;
		const getYCoordinate = ( evt ) => typeof evt.pageY === 'number' ? evt.pageY : evt.touches[0].pageY;

		const handleDragEnd = ( evt ) => {
			if ( !touch.started )
			{
				let finalIndex = 0;
				
				finalIndex = Math.round( touch.position / step * -1 );

				if ( finalIndex === currentIndex )
				{
					finalIndex = finalIndex - touch.direction;
				}

				if ( finalIndex < 0 )
				{
					finalIndex = 0;
				}
				else if ( finalIndex >= slidesCount )
				{
					finalIndex = slidesCount - 1;
				}

				currentIndex = finalIndex;
				slidesContainer.classList.add( 'sliding' );
				slidesContainer.transition = '';
				slidesContainer.style.transform = `translateX( ${currentIndex * -100}% )`;

				setTimeout( () => {
					bookmarksContainer.querySelector( '.current' ).classList.remove( 'current' );
					bookmarksContainer.children[currentIndex].classList.add( 'current' );
					slidesContainer.classList.remove( 'sliding', 'grabbing' );
				}, 450 );
			}

			touch = null;
			currentPosition = currentIndex * step * -1;
			document.removeEventListener( 'mousemove', handleDragMove );
			document.removeEventListener( 'touchmove', handleDragMove );
			document.removeEventListener( 'mouseleave', handleDragEnd );
			document.removeEventListener( 'mouseout', handleDragEnd );
			document.removeEventListener( 'mouseup', handleDragEnd );
			document.removeEventListener( 'touchcancel', handleDragEnd );
			document.removeEventListener( 'touchend', handleDragEnd );
			document.removeEventListener( 'touchleave', handleDragEnd );
		}
		
		const handleDragMove = ( evt ) =>
		{
			if ( !touch.started && !slidesContainer.classList.contains( 'sliding' ) )
			{
				return;
			}
			
			const xCoordinate = getXCoordinate( evt );
			const yCoordinate = getYCoordinate( evt );


			if ( touch.started )
			{
				touch.started = false;
				
				if ( Math.abs( touch.xCoordinate - xCoordinate ) >= Math.abs( touch.yCoordinate - yCoordinate ) )
				{
					slidesContainer.classList.add( 'sliding' );
				}
				else
				{
					return;
				}
			}

			if ( evt.cancelable )
			{
				evt.preventDefault();
			}
			
			const direction = touch.xCoordinate < xCoordinate ? 1 : -1;
			const diff = Math.abs( touch.xCoordinate - xCoordinate );
			
			touch.position = currentPosition + diff * direction;

			if ( touch.position > 0 || touch.position < slidesLength * -1 )
			{
				touch.position = currentPosition + diff / 10 * direction;
			}

			slidesContainer.style.transform = `matrix( 1, 0, 0, 1, ${touch.position}, 0 )`;
			touch.direction = direction;
			currentPosition = touch.position;
			touch.xCoordinate = xCoordinate;
		}
		
		const handleDragStart = ( evt ) => {
			if (
				window.innerWidth >= 1100
			||	( evt.timeStamp === timeStamp )
			||	( evt.button && evt.button > 0 )
			||	( evt.touches && evt.touches.length !== 1 )
			||	slidesContainer.classList.contains( 'sliding' )
			)
			{
				return;
			}
	
			if ( evt.type === 'mousedown' )
			{
				evt.preventDefault();
			}
	
			timeStamp = evt.timeStamp;
			slidesContainer.classList.add( 'grabbing' );
			slidesContainer.style.transition = 'none';
	
			touch = {
				position: currentPosition,
				started: true,
				xCoordinate: getXCoordinate( evt ),
				yCoordinate: getYCoordinate( evt )
			};
	
			document.addEventListener( 'mousemove', handleDragMove );
			document.addEventListener( 'touchmove', handleDragMove, {passive: false} );
			document.addEventListener( 'mouseup', handleDragEnd );
			document.addEventListener( 'touchcancel', handleDragEnd );
			document.addEventListener( 'touchend', handleDragEnd );
			document.addEventListener( 'touchleave', handleDragEnd );
		};
		
		bookmarksContainer.addEventListener( 'click', ( evt ) => {
			if ( window.innerWidth >= 1100 || !evt.target.dataset.step )
			{
				return;
			}

			currentIndex = Number( evt.target.dataset.step );

			slidesContainer.style.transform = `translateX( ${currentIndex * -100}% )`;
			bookmarksContainer.querySelector( '.current' ).classList.remove( 'current' );
			evt.target.parentNode.classList.add( 'current' );
		} );

		slidesContainer.addEventListener( 'mousedown', handleDragStart );
		slidesContainer.addEventListener( 'touchstart', handleDragStart, {passive: true} );
	}

	const handleResize = () => {
		if ( slidesContainer && bookmarksContainer )
		{
			if ( window.innerWidth >= 1100 )
			{
				slidesContainer.removeAttribute( 'style' );
			}
			
			step = window.innerWidth;
			slidesLength = step * ( slidesCount - 1 );
		}
	};

	handleResize();
	window.addEventListener( 'resize', handleResize );
};


//////////////////
// WEBPACK FOOTER
// ./app/Routes/Choose/Card/newCard.js
// module id = ti1i
// module chunks = 11